<mat-toolbar>
  <a mat-icon-button [routerLink]="['/search']" aria-label="Back to search menu">
    <mat-icon>arrow_back_ios_new</mat-icon>
  </a>
  <span>{{"SEARCH.FAVOURITE_PLAYERS" | translate}}</span>
</mat-toolbar>

<div class="app-page">
  @if (isLoading) {
    <div class="loader-wrap">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }

  @if (!isLoading && !loadError && players.length === 0) {
    <div class="empty-state">
      <mat-icon>info</mat-icon>
      <span>{{"SEARCH.NO_FAVOURITE_PLAYERS_FOUND" | translate}}</span>
    </div>
  }

  @if (!isLoading && loadError) {
    <div class="empty-state">
      <mat-icon>error_outline</mat-icon>
      <span>{{"SEARCH.COULD_NOT_LOAD_FAVOURITE_PLAYERS" | translate}}</span>
    </div>
  }

  @if (!isLoading && players.length > 0) {
    <div class="player-list">
      @for (player of players; track getPlayerId(player)) {
        <div class="player-row">
          <div class="player-details">
            <a class="player-name" [routerLink]="['/player/details', getPlayerId(player)]">
              {{ getPlayerName(player) }}
            </a>
            <div class="player-meta">
              <span>{{ getPositionId(player) | position }}</span>
              @if (getDivisionName(player)) {
                <span>{{ getDivisionName(player) }}</span>
              }
              @if (getTeamName(player)) {
                <span>{{ getTeamName(player) }}</span>
              }
            </div>
          </div>

       <!--    <div class="player-counts">
            <span>{{ getGamesCount(player) }} games</span>
            <span>{{ getReportsCount(player) }} reports</span>
          </div>
 -->
<!--           <a mat-stroked-button color="primary" [routerLink]="['/player/details', getPlayerId(player)]">
            Open player
          </a> -->
        </div>
      }
    </div>
  }
</div>